import React from "react";

function SoundOffIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16">
            <g fill="#637590">
                <path d="M12.222 3.33c.294-.323.312-.787.04-1.035-.273-.247-.732-.185-1.027.139l-8.537 9.393c-.295.324-.313.787-.04 1.035.272.248.732.186 1.027-.139l8.537-9.392z" />
                <path
                    opacity=".3"
                    d="M11.957 10.766a.5.5 0 1 1-.488-.873 2.166 2.166 0 0 0 .014-3.777.5.5 0 0 1 .495-.87 3.165 3.165 0 0 1-.021 5.52z"
                />
                <path
                    opacity=".3"
                    d="m5.747 10.666-2.262-.452a1.333 1.333 0 0 1-1.071-1.307V7.093c0-.636.448-1.183 1.071-1.308l2.262-.452 2.195-2.195a.667.667 0 0 1 1.138.471v8.781a.667.667 0 0 1-1.138.472l-2.195-2.196z"
                />
            </g>
            <defs>
                <clipPath id="r93f4bfiza">
                    <path fill="#fff" d="M0 0h16v16H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default SoundOffIcon;
